import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import validator from 'validator'

import PageHeading from '../../PageHeading/PageHeading';
import { DEBOUNCE_TIME, GLOBAL_SHOP_ID, IMG_PLACEHOLDER_PRODUCT, MAIN_DOMAIN, ORDERS_ITEM_LINK, ORDERS_MAIN_LINK, PLATFORM_MAIN_LINK, PROMOCODES_MAIN_LINK, SETTINGS_MAIN_LINK, SETTINGS_USERS_LINK } from '../../../../assets/utils/constants';
import ItemForm from '../../ItemForm/ItemForm';
import PlatformInput from '../../PlatformInput/PlatformInput';
import './OrdersCreate.css';
import mainApi from '../../../../assets/api/MainApi';
import { UserContext } from '../../../../assets/contexts/userContext';
import PreloaderBox from '../../../PreloaderBox/PreloaderBox';
import { createAction, hasPermission, parseApiError, parsePermissions, parsePrice } from '../../../../assets/utils/utils';
import { PERMISSIONS, RBAC_USER_MANAGEMENT } from '../../../../assets/utils/permissions_rbac';
import useAutoDismissError from '../../../../assets/hooks/useAutoDismissError';
import ErrorMessage from '../../../ErrorMessage/ErrorMessage';
import Button from '../../../Button/Button';
import AddProductPopup from './AddProductPopup/AddProductPopup';
import ProductsList from '../../ProductsList/ProductsList';
import { CrossIcon, DeleteCrossIcon } from '../../../../assets/icons/controls/controls';
import { EditIcon } from '../../../../assets/icons/category/category';
import EditProductPopup from './EditProductPopup/EditProductPopup';


function parseTitleForParts(input) {
    const separator = "||";

    // Check if the input contains the separator
    if (input.includes(separator)) {
        const [title, subtitle] = input.split(separator);
        return {
            title: title.trim(),
            subtitle: subtitle.trim(),
        };
    }

    // If no separator, return title and null subtitle
    return {
        title: input.trim(),
        subtitle: null,
    };
}



function OrdersCreate() {
    const navigate = useNavigate()

    const [values, setVelues] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        data: [],
        payment_type_crypto: true,
    })


    const [valuesValidity, setVeluesValidity] = useState({
        email: {},
        phone: {},
    })

    const [preloaders, setPreloaders] = useState({
        save: false,
    })


    const { user } = useContext(UserContext)
    const [error, showError] = useAutoDismissError()

    function handleSave() {
        setPreloaders(prevValue => ({
            ...prevValue,
            save: true,
        }))
        mainApi.createAdminOrder({
            shop_id: user.default_shop._id,
            email: values.email,
            phone: values.phone.replace(/\D/g, ''),
            data: values.data.map((item) => {
                if (item.type === 'from-site') {
                    return {
                        item_id: item._id,
                        options: [],
                        amount: `${item.amount}`,
                        price: `${item.price}`
                    }
                } else {
                    return {
                        name: item.name,
                        amount: `${item.amount}`,
                        price: `${item.price}`
                    }
                }
            }),
            delivery_type: 'no_delivery',
            payment_type: values.payment_type_crypto ? 'cryptocloud' : 'stripe',
            return_url: values.payment_type_crypto ? null : 'https://' + MAIN_DOMAIN,
            first_name: values.first_name,
            last_name: values.last_name,
        })
            .then((res) => {
                console.log(res)
                navigate(`${PLATFORM_MAIN_LINK}/${ORDERS_MAIN_LINK}/${ORDERS_ITEM_LINK}/${res._id}`)
            })
            .catch((err) => {
                console.log(err)
                showError(parseApiError(err))
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    save: false,
                }))
            })
    }



    function isSaveInactive() {
        // Consolidate the condition to determine the "Save" button's inactive state
        return !(values.phone && valuesValidity.phone.validState && values.email && valuesValidity.email.validState && values.data && values.data.length && values.first_name && values.last_name);
    }

    function addActionsBasedOnPermissions() {
        const actions = [];

        actions.push(createAction('Cоздать', handleSave, {
            isMainAction: true,
            inactive: isSaveInactive(),
            isPreloaderVisible: preloaders.save,
        }));

        return actions;
    }

    const actions = addActionsBasedOnPermissions();

    function handleChange(e) {
        const input = e.target;
        let value = input.value;
        const name = input.name

        switch (name) {

            case "email": {
                setVeluesValidity((prevValue) => ({
                    ...prevValue,
                    [name]: {
                        errorMessage: "",
                        validState: false,
                    },
                }));
                setVelues((prevValue) => ({
                    ...prevValue,
                    [name]: value,
                }));
                break;
            }

            case "phone": {
                let inputValue = e.target.value.replace(/\D/g, '')
                let formattedInputValue = '';
                if (!inputValue) {
                    setVelues(prevValue => ({
                        ...prevValue,
                        [name]: '',
                    }))
                    setVeluesValidity((prevValue) => ({
                        ...prevValue,
                        [name]: {
                            errorMessage: 'Можно вводить только цифры',
                            validState: false
                        }
                    }))
                }
                else {
                    if (['7', '8', '9'].indexOf(inputValue[0]) > -1) {
                        setVeluesValidity((prevValue) => ({
                            ...prevValue,
                            [name]: {
                                errorMessage: '',
                                validState: false
                            }
                        }))
                        if (inputValue[0] === '9') inputValue = '7' + inputValue;

                        let firstSimbols = (inputValue[0] === '8') ? '8' : '+7';
                        formattedInputValue = firstSimbols + ' '

                        if (inputValue.length > 1) {
                            formattedInputValue += '(' + inputValue.substring(1, 4)
                        }
                        if (inputValue.length >= 5) {
                            formattedInputValue += ') ' + inputValue.substring(4, 7)
                        }
                        if (inputValue.length >= 8) {
                            formattedInputValue += '-' + inputValue.substring(7, 9)
                        }
                        if (inputValue.length >= 10) {
                            formattedInputValue += '-' + inputValue.substring(9, 11)
                        }
                        if (inputValue.length >= 11) {
                            setVeluesValidity((prevValue) => ({
                                ...prevValue,
                                [name]: {
                                    errorMessage: '',
                                    validState: true
                                }
                            }));
                        } else {
                            setVeluesValidity((prevValue) => ({
                                ...prevValue,
                                [name]: {
                                    errorMessage: '',
                                    validState: false
                                }
                            }));
                        }
                    } else {
                        formattedInputValue = '+' + inputValue.substring(0, 16)
                        if (inputValue.length >= 11) {
                            setVeluesValidity((prevValue) => ({
                                ...prevValue,
                                [name]: {
                                    errorMessage: '',
                                    validState: true
                                }
                            }));
                        } else {
                            setVeluesValidity((prevValue) => ({
                                ...prevValue,
                                [name]: {
                                    errorMessage: 'invalid phone',
                                    validState: false
                                }
                            }));
                        }
                    }


                    setVelues(prevValue => ({
                        ...prevValue,
                        [name]: formattedInputValue,
                    }))
                }

                break;
            }

            default:
                setVelues(prevValue => ({
                    ...prevValue,
                    [name]: value,
                }))
                break;
        }
    }


    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            console.log(values.email)
            if (!values.email || values.email.length === 0) return
            if (!values.email) {
                setVeluesValidity((prevValue) => ({
                    ...prevValue,
                    email: {
                        errorMessage: "",
                        validState: false,
                    },
                }));
            }
            if (values.email.length >= 5) {
                if (validator.isEmail(values.email)) {
                    setVeluesValidity((prevValue) => ({
                        ...prevValue,
                        email: {
                            errorMessage: "",
                            validState: true,
                        },
                    }));
                    // ADD LOGIC TO CHECK UNIQUNESS OF EMAIL IN CURRENT SHOP/SYSTEM
                } else {
                    setVeluesValidity((prevValue) => ({
                        ...prevValue,
                        email: {
                            errorMessage: "Несуществующая эл. почта",
                            validState: false,
                        },
                    }));
                }
            }

        }, DEBOUNCE_TIME)

        return () => {
            clearTimeout(delayDebounceFn);
        }
    }, [values.email])

    const [popups, setPopups] = useState({
        addProduct: false,
        editProduct: false,
    })

    function handleCloseAddProductPopup() {
        setPopups(prevValue => ({
            ...prevValue,
            addProduct: false,
        }))
    }

    function handleAddItem(item) {
        console.log(item)

        handleCloseAddProductPopup()
        setVelues(prevValue => ({
            ...prevValue,
            data: prevValue.data && prevValue.data.length > 0 ? prevValue.data.concat([item]) : [item],
        }))
    }

    function handleDeleteItem(item) {
        setVelues(prevValue => ({
            ...prevValue,
            data: prevValue.data && prevValue.data.length > 1 ? prevValue.data.filter((obj) => obj._id !== item._id) : null,
        }))
    }
    const [productToEdit, setProductToEdit] = useState(null)
    function handleEditProduct(item) {
        setProductToEdit(item)
        setPopups(prevValue => ({
            ...prevValue,
            editProduct: true,
        }))
    }

    function handleCloseEditProductPopup() {
        setPopups(prevValue => ({
            ...prevValue,
            editProduct: false,
        }))
    }
    function handleEditSave(item) {
        setVelues(prevValue => ({
            ...prevValue,
            data: prevValue.data.map((obj) => {
                if (obj._id !== item._id) return obj
                else return {
                    ...obj,
                    ...item,
                }
            }),
        }))
    }
    return (

        <div className='order-create'>
            <PageHeading
                className={'order-create__heading'}
                title={'Новый заказ'}
                goBack={{
                    onClick: () => { navigate(`${PLATFORM_MAIN_LINK}/${ORDERS_MAIN_LINK}`) },
                }}
                actions={actions}
            />
            <ErrorMessage error={error} />
            <ItemForm>
                <div className='order-create_form'>
                    <div className='order-create_form-column'>
                        <PlatformInput
                            value={values.phone}
                            placeholder={''}
                            label={'Телефон клиента'}
                            // hint={'Видно только вам'}
                            handleChange={handleChange}
                            name={'phone'}
                        >
                        </PlatformInput>
                        <PlatformInput
                            value={values.email}
                            placeholder={''}
                            label={'Эл. почта клиента'}
                            // hint={'Видно только вам'}
                            handleChange={handleChange}
                            name={'email'}
                            error={valuesValidity.email.errorMessage ? valuesValidity.email.errorMessage : ''}
                        >
                        </PlatformInput>
                        <PlatformInput
                            value={values.first_name}
                            placeholder={''}
                            label={'Имя клиента'}
                            // hint={'Видно только вам'}
                            handleChange={handleChange}
                            name={'first_name'}
                        >
                        </PlatformInput>
                        <PlatformInput
                            value={values.last_name}
                            placeholder={''}
                            label={'Фамилия клиента'}
                            // hint={'Видно только вам'}
                            handleChange={handleChange}
                            name={'last_name'}
                        >
                        </PlatformInput>
                        {user.default_shop._id === GLOBAL_SHOP_ID ?
                            <PlatformInput
                                value={values.payment_type_crypto}
                                placeholder={""}
                                label={"Метод оплаты"}
                                // hint={'Видно только вам'}
                                handleChange={handleChange}
                                name={"payment_type_crypto"}
                                boolean_values={{
                                    true: {
                                        title: "Крипта (USDT)",
                                    },
                                    false: {
                                        title: "Stripe (Карта)",
                                    },
                                }}
                                isBooleanSelector={true}
                            />
                            : null}

                    </div>
                    <div className='order-create_form-column'>
                        <p className='order-create_form-column-title'>Товары</p>
                        <AddProductPopup
                            isOpen={popups.addProduct}
                            handleClose={handleCloseAddProductPopup}
                            items={values.data}
                            handleAddItem={handleAddItem}

                        />
                        <EditProductPopup
                            isOpen={popups.editProduct}
                            handleClose={handleCloseEditProductPopup}
                            handleEditSave={handleEditSave}
                            productToEdit={productToEdit}
                            setProductToEdit={setProductToEdit}
                        />
                        {values.data && values.data.length > 0 ?
                            <div className='order-create__items'>
                                {values.data.map((item, i) => (
                                    <div className='order-create__item' key={`order-create__item${i}`}>
                                        <img
                                            // src={IMG_PLACEHOLDER_PRODUCT}
                                            src={item.files && item.files.length > 0 ? item.files[0].urls.orig : IMG_PLACEHOLDER_PRODUCT}
                                            className='order-create__item-img'
                                            alt=''
                                        />
                                        <div className='order-create__item-info'>
                                            <div className='order-create__item-controls'>
                                                <button className='order-create__item-control' type='button' onClick={() => {
                                                    handleEditProduct(item)
                                                }}>
                                                    <EditIcon
                                                        mainClassName={'order-create__item-control-icon order-create__item-control-icon_edit'}
                                                        fillClassName={'order-create__item-control-icon-fill'}
                                                    />
                                                </button>
                                                <button className='order-create__item-control' type='button' onClick={() => {
                                                    handleDeleteItem(item)
                                                }}>
                                                    <CrossIcon
                                                        mainClassName={'order-create__item-control-icon'}
                                                        fillClassName={'order-create__item-control-icon-fill'}
                                                    />
                                                </button>
                                            </div>
                                            <h3 className={`order-create__item-info-title`}>{item.name && item.name.length > 0 ? parseTitleForParts(item.name).title : ` `}</h3>
                                            <p className={`order-create__item-info-subtitle`}>{item.name && item.name.length > 0 ? parseTitleForParts(item.name).subtitle : ` `}</p>
                                            <div className='order-create__item-info-separator'></div>
                                            <div className='order-create__item-info-price-and-count'>
                                                <p className='order-create__item-info-price'>{parsePrice(item.price, 'USD')}</p>
                                                <div className='order-create__item-info-price-and-count-separator' />
                                                <p className='order-create__item-info-count'>{Number(item.amount)} шт.</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            : null}
                        <div className='order-create__product-btns'>
                            <Button
                                isContrastColor={true}
                                text={'Добавить товар'}
                                className={'order-create__product-btn'}
                                onClick={() => {
                                    setPopups(prevValue => ({
                                        ...prevValue,
                                        addProduct: true,
                                    }))
                                }}
                            />
                        </div>

                    </div>
                </div>
            </ItemForm>
        </div>


    );
}

export default OrdersCreate